import request from '../utils/request';
import newRequest from '../utils/newRequest';
/**
 * @description: 查询省
 * @param {*} data 
 */
export function selectAreaProvince(data) {
  return request({
    url: '/api/weixin/selectAreaProvince',
    method: 'post',
    data,
  })
}
/**
 * @description: 查询市
 * @param {*} data 
 */
 export function selectAreaCity(data) {
  return request({
    url: '/api/weixin/selectAreaCity',
    method: 'post',
    data,
  })
}
/**
 * @description: 查询县/区
 * @param {*} data 
 */
 export function selectAreaDistrict(data) {
  return request({
    url: '/api/weixin/selectAreaDistrict',
    method: 'post',
    data,
  })
}
/**
 * @description: 公众号销售网点分页列表
 * @param {*} data 
 */
 export function pageStoreDo(data) {
  return newRequest({
    // url: '/api/weixin/pageStoreDo',
    url:'/backend/sale-channel-center/app/officialAccount/pageStoreDo',
    method: 'post',
    data,
  })
}